import { PropsWithChildren } from 'react';
import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import ApplicationNavigation from './navigation/application-level/ApplicationNavigation';
import PageNavigation from './navigation/application-level/PageNavigation';
import Footer from './footer/Footer';
import ContentFooter from './content/ContentFooter';

type PageProps = PropsWithChildren;

export default function ApplicationLevelLayout({ children }: PageProps) {
  const breakpoint = useBreakpoint();

  return (
    <div className="page">
      {breakpoint !== 'mobile' && <PageNavigation />}
      <div className="page-content">
        <ApplicationNavigation />
        <div className="main-layout">
          <div className="main-layout-container">
            <div className="content-layout">
              <main>
                <div className="margin-wrapper">
                  {children}
                  <ContentFooter>
                    <Footer />
                  </ContentFooter>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
